/**
 * OpenCC correctly handles general Simplified Chinese, but a few astrology
 * proper nouns must keep their conventional forms in Traditional Chinese.
 */
export function normalizeTraditionalAstrologyTerms(value: string): string {
  const normalized = value
    .replaceAll('紫微鬥數', '紫微斗數')
    .replaceAll('鬥數', '斗數')
    .replaceAll('醜時', '丑時')
    .replaceAll('醜宮', '丑宮')
    .replace(/([甲乙丙丁戊己庚辛壬癸])醜/g, '$1丑')
    .replaceAll('覆盤', '復盤');
  // React may render the stem and branch as adjacent, separate text nodes.
  if (normalized === '醜') return '丑';
  if (normalized === '鬥') return '斗';
  return normalized;
}
